import { Head } from "@inertiajs/react"
import { useTranslation } from "react-i18next"

import { SuccessArrival } from "@/components/onboarding/success-arrival"

export interface ArrivalBrand {
  name: string
  logo_url: string | null
  cover_image_url: string | null
}

export interface ArrivalInviter {
  name: string
  initials: string
}

export interface ArrivalProps {
  /** Inviting brand chrome (name + logo + full-bleed cover). Resolved
   *  server-side from the invite token and membership-guarded — brand
   *  isolation P0. */
  brand: ArrivalBrand
  /** OKS-458 — inviter `{name, initials}` (or null). Carried on the
   *  contract for a future arrival variant; the current composition
   *  doesn't surface an inviter row. */
  inviter: ArrivalInviter | null
  /** The freshly-signed-up creator's own name (welcome copy). */
  creator_name: string
}

/**
 * OKS-458 — §02 immersive arrival page (`GET /sign_up/welcome`).
 *
 * Rendered by `SignupWelcomesController#show` after a successful invite
 * signup, replacing the V1 silent 303 → /onboarding. A full-screen
 * branded "you're on the crew" moment that hands off to the first
 * mission via the `<SuccessArrival>` CTA (`creatorMissionsPath()`).
 *
 * Deliberately NOT wrapped in `PublicLayout` (or any centred-card
 * chrome) — the arrival is full-bleed, owning the entire viewport.
 */
export default function Arrival({ brand, creator_name }: ArrivalProps) {
  const { t } = useTranslation()

  return (
    <>
      <Head>
        <title>{t("signup_arrival.head_title")}</title>
      </Head>
      <SuccessArrival
        brandName={brand.name}
        brandLogoUrl={brand.logo_url}
        coverImageUrl={brand.cover_image_url}
        creatorName={creator_name}
      />
    </>
  )
}
